import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { DrillGrade } from "./Drill";

// Оценка ответа: верно, почти (засчитано наполовину), мимо.
export const GRADE_LABELS: Record<DrillGrade, MessageDescriptor> = {
  right: msg({ id: "drills.grade.right", message: "Right" }),
  close: msg({ id: "drills.grade.close", message: "Close" }),
  wrong: msg({ id: "drills.grade.wrong", message: "Wrong" }),
};
